import Parse from "parse";
import { CustomUser } from "../classes";

Parse.initialize(
  process.env.REACT_APP_APP_ID,
  process.env.REACT_APP_JAVASCRIPT_KEY,
  process.env.REACT_APP_MASTER_KEY
);
Parse.masterKey = process.env.REACT_APP_MASTER_KEY;
Parse.serverURL = process.env.REACT_APP_SERVER_URL;

export const authProvider = {
  login: async (params) => {
    const { username, password } = params;

    try {
      if (!username || !password) {
        throw new Error("username and password are required.");
      }
      // if (username.includes("@")) {
      //   throw new Error("Username cannot be an email address.");
      // }
      const response = await Parse.Cloud.run("caseInsensitiveLogin", {
        username,
        password,
      });

      localStorage.setItem("role", response?.user?.roleName);

      const user = await CustomUser.logIn(response?.user?.username, password);
      await user.setLastLogin();
      await user.incrementLoginCount();
      await user.setOnline(true);

      // return Promise.resolve();
      return {
        userBalance: user.get("balance"),
        role: response?.user?.roleName,
      };
    } catch (error) {
      return Promise.reject(error);
    }
  },
  // checkError: async ({ status }) => {
  //   if (status === 401 || status === 403) {
  //     Parse.User.current().then(() =>
  //       Parse.User.logOut().then(() => {
  //         const currentUser = Parse.User.current();
  //       })
  //     );
  //     return Promise.reject();
  //   }
  //   return Promise.resolve();
  // },
  checkError: async (error) => {
    const isInvalidSession =
      error?.status === 401 ||
      error?.status === 403 ||
      error?.message?.toLowerCase().includes("invalid session token") ||
      error?.code === 209;

    if (isInvalidSession) {
      console.warn("Invalid session detected, logging out...");

      try {
        await Parse.User.logOut();
      } catch (err) {
        console.error("Error during logout:", err);
      }

      // Clear stored auth data
      localStorage.removeItem("role");
      localStorage.removeItem("_grecaptcha");
      localStorage.removeItem(
        `Parse/${process.env.REACT_APP_APP_ID}/sessionToken`
      );
      localStorage.removeItem(
        `Parse/${process.env.REACT_APP_APP_ID}/currentUser`
      );

      return Promise.reject();
    }

    return Promise.resolve();
  },
  checkAuth: async (params) => {
    return Parse.User.current() ? Promise.resolve() : Promise.reject();
  },
  logout: async () => {
    try {
      const user = Parse.User.current();

      if (!user) {
        return Promise.resolve(); // Nothing to do if user is not logged in
      }

      const userId = user.id; // Save before logOut()

      // Update isOnline flag
      await user.save({ isOnline: false });

      // Clear stored auth data
      localStorage.removeItem("role");
      localStorage.removeItem("_grecaptcha");
      localStorage.removeItem(
        `Parse/${process.env.REACT_APP_APP_ID}/sessionToken`
      );
      localStorage.removeItem(
        `Parse/${process.env.REACT_APP_APP_ID}/currentUser`
      );

      await Parse.User.logOut();
      window.location.replace("/login");

      try {
        await Parse.Cloud.run("logoutAllSessions", { userId });
      } catch (cloudError) {
        console.warn("Failed to logout all sessions:", cloudError);
      }

      return Promise.resolve();
    } catch (error) {
      throw Error(error.toString());
    }
  },
  getIdentity: async () => {
    let user = Parse.User.current();

    // Restore session if user is null
    if (!user) {
      const sessionToken = localStorage.getItem(
        `Parse/${process.env.REACT_APP_APP_ID}/sessionToken`
      );

      if (sessionToken) {
        console.log("Restoring session...");
        try {
          user = await Parse.User.become(sessionToken);
        } catch (err) {
          console.error("Session restoration failed:", err);
          throw new Error("Session expired. Please log in again.");
        }
      } else {
        throw new Error("No active session found.");
      }
    }

    // Ensure the user is fully fetched
    user = await user.fetch();

    // const user = Parse.User.current();
    const userRole = await user.get("role");
    await userRole.fetch();

    const manager = await user.get("manager");
    const managerRole = await manager.get("role");
    return {
      userId: user.id,
      username: user.get("username"),
      userBalance: user.get("balance"),
      userRoleId: userRole.id,
      userRoleName: userRole.get("name"),
      email: user.get("email"),
      managerId: manager.id,
      // managerName: manager.get("username"),
      // managerRoleName: managerRole.get("name"),
      // managerRoleId: managerRole.id,
      phone: user.get("phone"),
      loginTimes: user.get("loginTimes"),
      lastLogin: user.get("lastLogin"),
      createdAt: user.get("createdAt"),
      sessionToken: user.getSessionToken(),
    };
  },
  getPermissions: async () => {
    const currentUserData = localStorage.getItem("role");
    const roleName = currentUserData;
    return roleName;
  },
};

export const changePassword = async (
  currentPassword,
  newPassword,
  confirmPassword
) => {
  try {
    // Ensure the new password and confirm password match
    if (newPassword !== confirmPassword) {
      throw new Error("New password and confirm password do not match.");
    }

    // Validate password length
    if (newPassword.length < 6) {
      throw new Error("Password must be at least 6 characters long.");
    }

    // Get the current user
    const currentUser = Parse.User.current();
    if (!currentUser) {
      throw new Error("User not authenticated.");
    }

    // Validate current password using Parse's login function
    const username = currentUser.get("username");
    try {
      await Parse.Cloud.run("caseInsensitiveLogin", {
        username,
        password: currentPassword,
      });
    } catch (error) {
      throw new Error("Current password is incorrect.");
    }

    // Update password
    currentUser.setPassword(newPassword);
    await currentUser.save();

    await Parse.User.logOut();

    return "Password changed successfully. Please log in again.";
  } catch (error) {
    throw new Error(error.message);
  }
};
